import { Routes, RouterModule } from "@angular/router";
import { HomeComponent } from  "./components/home";
import { LoginComponent } from  "./components/login";
import { LoginDevComponent } from  "./components/loginDev";
import { LogoutComponent } from  "./components/logout";
import { GatewayComponent } from  "./components/gateway";
import { AboutComponent } from  "./components/about";
import { ErrorComponent } from  "./components/error";



// const logindev = (process.env.NODE_ENV === 'development') ? LoginDevComponent : LoginComponent;

const appRoutes: Routes = [
    { path: "", redirectTo: "/myhome", pathMatch: "full" },
    { path: "home", component: HomeComponent },
    { path: "login", component: LoginComponent },
    { path: "gateway", component: GatewayComponent },
    { path: "about", component: AboutComponent },
    { path: "error", component: ErrorComponent },
    { path: "logout", component: LogoutComponent },
];

export const APPROUTING = RouterModule.forRoot(appRoutes, { useHash: true });




// WEBPACK FOOTER //
// ./src/app/app.routes.ts